import React from 'react'

export default function Container3() {
  return (
    <div className='container my-5' id="Container3">
    <h3 className='fw-bold'>Unkompliziert und Effektiv</h3>
    <h1 className='fw-bold'> <span className='text-success1'>Super einfache</span> Umsetzung</h1>
    <div className='row pt-3 contflex3'>
    <div className='col-lg-6 col-md-12 col-sm-12 contf1'>
    <h1 className='fw-bold py-2  d-lg-none fs-2' id='contf2headc'>Innovative Benutzeroberfläche</h1>
        <img src="./cont3graph.png" className='img-fluid text-center ' alt='not found'/>
    </div>
    <div className='col-lg-6 col-md-12 col-sm-12 contf2'>
        <h1 className='fw-bold py-2 d-none d-lg-block fs-2' id='contf2head'>Innovative Benutzeroberfläche</h1>
        <p className='pb-4 cont3para'>Unser Dashboard bietet Dir die Möglichkeit, Werbeanzeigen hochzuladen und zu verwalten, während Du gleichzeitig Zugang zu nützlichen Widgets wie Wetter und Nachrichten hast. Erstelle eine Blacklist, richte deinen Werberadius ein und beobachte deine Impressionen, um die Kontrolle über Deine Werbekampagnen zu behalten und gezielt Kunden am Hotspot verteilt in der Region anzusprechen.</p>
        <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn btn-success'>Jetzt Loslegen</button></a>
    </div>
    </div>
    
</div>
  )
}
